module.exports = __webpack_public_path__ + "static/14b22152.AE-328-p.png";